module.exports = __webpack_public_path__ + "static/media/speaker-page-row-2.73d7c0cc.png";